import { MdWhatsapp } from 'react-icons/md'

type FloatingButtonProps = {
  phone: string
  message: string
}

function FloatingButton({ phone, message }: FloatingButtonProps) {
  const formatPhone = (phone: string) => {
    return phone.replace(/\D+/g, '')
  }

  const url = `https://wa.me/${formatPhone(phone)}?text=${encodeURIComponent(message)}`

  return (
    <a
      href={url}
      className='radius-pill fixed bottom-6 right-6 flex h-[64px] w-[64px] items-center justify-center bg-black xl:hidden'
      target='_blank'
      rel='noreferrer'
      aria-label='WhatsApp'
    >
      <MdWhatsapp color='#fff' size={26} />
    </a>
  )
}

export default FloatingButton
